/* Estrani - productpagina: foto's filteren op kleur + pasadvies naast Maat.

   Waarom dit bestaat: van de foto's bij een product is er maar een per kleur
   aan een variant gekoppeld. De rest hangt nergens aan vast, dus Shopify toont
   ze bij elke kleur. Een klant die Khaki kiest, scrolt zo langs grijs en zwart.

   De oplossing gebruikt wat er al staat: in de alt-tekst van elke foto staat de
   kleur ("... in khaki, zijaanzicht"). Van de 1192 foto's in de winkel noemen er
   1095 precies een kleur en nul foto's noemen er twee. De 97 die geen kleur
   noemen zijn algemene detailfoto's; die blijven altijd staan.

   Er wordt NIETS aan de productgegevens veranderd. Geen foto's herkoppelen,
   niets verplaatsen, niets verwijderen. Alleen verbergen in beeld.

   Let op het wachtmoment hieronder: klik je een kleur aan, dan staat de nieuwe
   kleur meteen aangevinkt, maar haalt het thema de bijhorende foto's pas een
   kleine halve seconde later op. Filterden we in dat gaatje al, dan zag je even
   een verkeerde set voorbijkomen. Daarom wachten we tot de galerij echt
   vernieuwd is; dat herkennen we aan de alt-teksten die erin staan.

   Vangnet: zou een kleur nul foto's overhouden, dan toont hij alles. En blijft
   de galerij uit, dan filtert hij na 700 ms alsnog, zodat we nooit vastlopen.

   Door Claude gebouwd. Zie ai-productpagina.css om het uit te zetten. */

(function () {
  'use strict';

  var BEZIG = false;
  var KIJKER = null;
  var TIMER = null;
  var VORIGE_INHOUD = null;   /* welke foto's stonden er bij de vorige ronde */
  var VORIGE_KLEUR = null;    /* op welke kleur hebben we toen gefilterd */
  var VOORGELADEN = {};       /* welke kleuren we al opgehaald hebben */
  var WACHT_SINDS = null;     /* sinds wanneer wachten we op de nieuwe galerij */

  function ontdoe(s) {
    return (s || '').toLowerCase().replace(/[èéêë]/g, 'e');
  }

  function radios() {
    return document.querySelectorAll('variant-picker input[type="radio"][data-option-name]');
  }

  /* De aangevinkte kleur uit de variantkiezer. */
  function gekozenKleur() {
    var alle = radios();
    for (var i = 0; i < alle.length; i++) {
      var naam = alle[i].getAttribute('data-option-name') || '';
      if (/kleur|colou?r/i.test(naam) && alle[i].checked) return alle[i].value;
    }
    return null;
  }

  /* Alle kleurnamen van dit product, langste eerst zodat "gebroken wit" voor
     "wit" gaat. */
  function alleKleuren() {
    var uit = [];
    var alle = radios();
    for (var i = 0; i < alle.length; i++) {
      var naam = alle[i].getAttribute('data-option-name') || '';
      if (/kleur|colou?r/i.test(naam) && uit.indexOf(alle[i].value) < 0) uit.push(alle[i].value);
    }
    return uit.sort(function (a, b) { return b.length - a.length; });
  }

  function noemtKleur(tekst, kleur) {
    var k = ontdoe(kleur).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|[^a-z])' + k + '([^a-z]|$)').test(ontdoe(tekst));
  }

  function altVan(li) {
    var img = li.querySelector('img');
    return img ? (img.getAttribute('alt') || '') : '';
  }

  /* Een korte samenvatting van welke foto's er nu in de pagina staan. Verandert
     die, dan heeft het thema de galerij vernieuwd. */
  function inhoudVan(lijst) {
    var uit = [];
    for (var i = 0; i < lijst.length; i++) uit.push(altVan(lijst[i]));
    return uit.join('|');
  }

  /* De foto's van een kleur alvast ophalen.

     Waarom dit moet: ons filter zet de foto's van de andere kleuren op
     display:none, en een verborgen foto met loading="lazy" haalt de browser
     niet op. Wissel je dan van kleur, dan moet de eerste foto nog beginnen te
     laden terwijl ze al in beeld komt - en net dat zie je flikkeren. Het is
     dus een neveneffect van het filter zelf.

     Door de foto's op te halen zodra je een kleur AANWIJST of aanklikt, staan
     ze in de cache voor het thema de galerij vernieuwt (gemeten: dat gebeurt
     ruim zeshonderd milliseconden na de klik). Er wordt niets getoond of
     verplaatst; enkel opgehaald. */
  function voorladen(kleur) {
    if (!kleur || VOORGELADEN[kleur]) return;
    VOORGELADEN[kleur] = 1;

    var lijst = document.querySelectorAll('.product-media-container');
    var kleuren = alleKleuren();
    var gedaan = {};

    for (var i = 0; i < lijst.length; i++) {
      var img = lijst[i].querySelector('img');
      if (!img) continue;

      var alt = img.getAttribute('alt') || '';
      var van = null;
      for (var k = 0; k < kleuren.length; k++) {
        if (noemtKleur(alt, kleuren[k])) { van = kleuren[k]; break; }
      }
      /* Algemene foto's (geen kleur in de alt) horen bij elke kleur. */
      if (van !== null && van !== kleur) continue;

      var src = img.getAttribute('src');
      if (!src || gedaan[src]) continue;
      gedaan[src] = 1;

      var p = new Image();
      /* sizes en srcset meegeven, anders kiest de browser hier een andere
         maat dan ze straks nodig heeft en hebben we niets opgewarmd. */
      var sz = img.getAttribute('sizes');
      var ss = img.getAttribute('srcset');
      if (sz) p.sizes = sz;
      if (ss) p.srcset = ss;
      p.src = src;
    }
  }

  /* Welke foto's horen bij deze kleur? true = laten staan. */
  function watHouden(lijst, kleuren, kleur) {
    var houden = [];
    for (var i = 0; i < lijst.length; i++) {
      var alt = altVan(lijst[i]);
      /* Welke kleur noemt deze foto? De langste match telt. */
      var van = null;
      for (var k = 0; k < kleuren.length; k++) {
        if (noemtKleur(alt, kleuren[k])) { van = kleuren[k]; break; }
      }
      /* Geen kleur genoemd = algemene foto, die blijft altijd staan. */
      houden.push(van === null || van === kleur);
    }
    return houden;
  }

  /* Staat de opmaak nog zoals wij ze gezet hebben?

     Dit is er bijgekomen met Horizon 4.3.0. Dat thema zet sindsdien bij ELKE
     variantwissel alle foto's weer zichtbaar, ook als je enkel een maat
     aanklikt. De kleur is dan niet veranderd en de foto's ook niet, dus aan
     die twee zagen we het niet: we sprongen er met een snelkoppeling uit en
     het filter bleef uit. Resultaat: alle tien de foto's terug en tien
     bolletjes onder een galerij waar er maar vier te zien waren.
     Daarom kijken we nu ook naar de opmaak zelf. */
  function klopt(lijst, houden) {
    for (var i = 0; i < lijst.length; i++) {
      if (lijst[i].classList.contains('ai-pp-weg') === houden[i]) return false;
    }
    return true;
  }

  function filterGalerij(forceer) {
    var lijst = document.querySelectorAll('.product-media-container');
    if (!lijst.length) return;

    var kleur = gekozenKleur();
    var kleuren = alleKleuren();
    if (!kleur || kleuren.length < 2) return; /* een kleur: niets te filteren */

    var inhoud = inhoudVan(lijst);
    var houden = watHouden(lijst, kleuren, kleur);

    if (!forceer && VORIGE_INHOUD !== null && inhoud === VORIGE_INHOUD && kleur === VORIGE_KLEUR) {
      WACHT_SINDS = null;
      if (klopt(lijst, houden)) return; /* niets veranderd */
      /* De opmaak is gewist door het thema: meteen terugzetten, niet wachten. */
    } else if (!forceer && VORIGE_INHOUD !== null && inhoud === VORIGE_INHOUD) {
      /* De kleur is gewisseld maar de galerij nog niet. Even wachten, anders
         filteren we de oude foto's op de nieuwe kleur en zie je een sprongetje.

         LET OP de deadline hieronder. Eerst startte ik die wachttijd telkens
         opnieuw bij elke beweging op de pagina. Staat de winkelwagen open, dan
         beweegt er om de paar tienden van een seconde iets, en kwam de noodrem
         dus nooit aan bod: je bleef alle kleuren door elkaar zien. Nu tellen we
         vanaf het moment dat we de wissel OPMERKTEN, zodat er hoe dan ook
         binnen 700 ms gefilterd wordt. */
      var nu = Date.now();
      if (WACHT_SINDS === null) WACHT_SINDS = nu;
      if (nu - WACHT_SINDS < 700) {
        clearTimeout(TIMER);
        TIMER = setTimeout(function () { draai(true); }, 700 - (nu - WACHT_SINDS));
        return;
      }
      /* Deadline verstreken: toch filteren, met de kleur die nu gekozen is. */
    }

    WACHT_SINDS = null;
    clearTimeout(TIMER);

    var i;
    if (houden.filter(Boolean).length === 0) return; /* vangnet: liever alles dan niets */

    for (i = 0; i < lijst.length; i++) {
      lijst[i].classList.toggle('ai-pp-weg', !houden[i]);
    }

    VORIGE_INHOUD = inhoud;
    VORIGE_KLEUR = kleur;
  }

  /* Pasadvies uit de eigen productbeschrijving, niet uit een vaste tekst. */
  function pasadvies() {
    var koppen = document.querySelectorAll('h3');
    for (var i = 0; i < koppen.length; i++) {
      if (!/^maten$/i.test(koppen[i].textContent.trim())) continue;
      var p = koppen[i].nextElementSibling;
      if (!p) continue;
      var t = p.textContent;
      /* Volgorde telt: "slank; wil je het ruimer" is slank, niet ruim. */
      if (/slank|slim|getailleerd/i.test(t)) return 'Valt slank';
      if (/ruim/i.test(t)) return 'Valt ruim';
      if (/valt normaal/i.test(t)) return 'Valt normaal';
      return null;
    }
    return null;
  }

  function zetPasadvies() {
    var advies = pasadvies();
    if (!advies) return;
    var alle = radios();
    for (var i = 0; i < alle.length; i++) {
      var naam = alle[i].getAttribute('data-option-name') || '';
      if (!/maat|size/i.test(naam)) continue;
      var veld = alle[i].closest('fieldset') || alle[i].closest('.variant-option');
      if (!veld) continue;
      var lg = veld.querySelector('legend');
      if (!lg || lg.querySelector('.ai-pp__pas')) return;
      var span = document.createElement('span');
      span.className = 'ai-pp__pas';
      span.textContent = advies;
      lg.appendChild(span);
      return;
    }
  }

  function draai(forceer) {
    if (BEZIG) return;
    BEZIG = true;
    try { filterGalerij(forceer === true); zetPasadvies(); } catch (e) { /* nooit de pagina breken */ }
    BEZIG = false;
  }

  /* Kies je een kleur, dan hertekent het thema de keuzeblokken en de galerij.
     Deze kijker zet onze aanpassingen meteen terug, nog voor de browser tekent. */
  function kijk() {
    if (KIJKER) return;
    KIJKER = new MutationObserver(function () { draai(false); });
    KIJKER.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    if (!document.querySelector('variant-picker')) return;
    draai(false);
    kijk();
    /* Wijs je een kleur aan, dan halen we haar foto's al op. Zo is de eerste
       foto meestal al binnen voor je klikt. */
    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var lab = t.closest('variant-picker label');
      if (!lab) return;
      var inp = lab.control || document.getElementById(lab.getAttribute('for')) || lab.querySelector('input');
      if (!inp) return;
      if (/kleur|colou?r/i.test(inp.getAttribute('data-option-name') || '')) voorladen(inp.value);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-picker input[type=\"radio\"]')) {
        if (/kleur|colou?r/i.test(e.target.getAttribute('data-option-name') || '')) voorladen(e.target.value);
        setTimeout(function () { draai(false); }, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
